/*

The Eiis base Object class, object of all objects

 */
import Logger from "./Logger.js"

export default class Base {

	constructor(config) {
		this.id = this.generateId(10);

		const source = typeof config === 'function' ? config.call(this, config) : config;
		for (const key in source) {
			this[key] = source[key];
		}

		this.log = new Logger();
	}

	set setState(state) {
		const source = typeof state === 'function' ? state.call(this, state) : state;
		for (const key in source) {
			this[key] = source[key];
		}
	}

	/* handle event */
	handleEvent(event) {
		let n = event.type[0].toUpperCase() + event.type.substr(1);
		if (typeof this['on' + n] === 'function')
			this['on' + n](event);
		else
			console.error(this, 'Misfired event', event.type, n)
	}

	// dec2hex :: Integer -> String
	dec2hex (dec) {
		return ('0' + dec.toString(16)).substr(-2)
	}

	// generateId :: Integer -> String
	generateId (len) {
		var arr = new Uint8Array((len || 40) / 2)
		window.crypto.getRandomValues(arr)
		return Array.from(arr, this.dec2hex).join('')
	}
}
